/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Signoffdate1Inputs */

const en__field_signoffdate1 = /** @type {(inputs: _Field_Signoffdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`singoff`)
};

const de__field_signoffdate1 = /** @type {(inputs: _Field_Signoffdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmeldung`)
};

/**
* | output |
* | --- |
* | "singoff" |
*
* @param {_Field_Signoffdate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_signoffdate1 = /** @type {((inputs?: _Field_Signoffdate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Signoffdate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_signoffdate1(inputs)
	return de__field_signoffdate1(inputs)
});
export { _field_signoffdate1 as "_field_signoffDate" }